import { mockFormField, mockFormFieldset } from '@domgen/dgx-fe-forms/layout';
import { CmsPaperlessPreferenceFieldset } from '../../models/cms/cms-paperless-preference-fieldset.interface';

export const mockCmsPaperlessPreferenceFieldset: CmsPaperlessPreferenceFieldset =
  {
    ...mockFormFieldset,
    paperlessPreferenceBanner: 'paperlessPreferenceBanner',
    paperlessPreferenceField: mockFormField,
  };
